/**
 * @desc 列表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<ObjectMap>;
export function request(
  params: API.tms.customsClearanceDetails.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearanceDetails/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
